var map = {
	"./8ways_en.png": "a872",
	"./8ways_sc.png": "fc7a",
	"./8ways_tc.png": "3607",
	"./kids_1.png": "eb3f",
	"./kids_2.png": "1c72",
	"./kids_3.png": "264f",
	"./kids_4.png": "8fa5",
	"./kids_5.png": "0bb8",
	"./kids_6.png": "7009",
	"./kids_7.png": "0f8e",
	"./others_age.png": "1b80",
	"./others_court.png": "7d34",
	"./others_sd.png": "193e",
	"./protect_1.png": "62c5",
	"./protect_2.png": "aec5",
	"./protect_3.png": "d6be",
	"./protect_4.png": "fec5",
	"./protect_5.png": "d5de",
	"./protect_6.png": "2db3",
	"./protect_7.png": "604c5",
	"./protect_8.png": "b04e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d1b";